// extracted by mini-css-extract-plugin
export default {"trunkedRow":"AddNetwork_trunkedRow__mfOnT","button":"AddNetwork_button__pf1M9"};